import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/not-found')({
  component: NotFoundPage,
})

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-4xl font-bold text-ink mb-4">404</h1>
      <p className="text-lg text-gray-500 mb-8">Страница не найдена</p>
      <a href="/" className="btn btn-primary">
        На главную
      </a>
    </div>
  )
}


